// userActions.js
import { http } from "../axios";

export const fetchInitStart = () => ({
  type: "FETCH_INIT_START",
});

export const fetchInitSuccess = (statusData) => ({
  type: "FETCH_INIT_SUCCESS",
  payload: statusData,
});

export const fetchInitFailure = (error) => ({
  type: "FETCH_INIT_FAILURE",
  payload: error,
});

export const fetchInit = (user_no, user_lang) => async (dispatch) => {
  dispatch(fetchInitStart());
  try {
    const res = await http.get(
      `api/init?user_no=${user_no}&user_lang=${user_lang}`,
    );
    if (res.status !== 200) {
      throw new Error("Failed to fetch init data");
    }
    const initData = await res.data;
    dispatch(fetchInitSuccess(initData));
  } catch (error) {
    dispatch(fetchInitFailure(error.message));
  }
};

export const fetchStatusStart = () => ({
  type: "FETCH_STATUS_START",
});

export const fetchStatusSuccess = (statusData) => ({
  type: "FETCH_STATUS_SUCCESS",
  payload: statusData,
});

export const fetchStatusFailure = (error) => ({
  type: "FETCH_STATUS_FAILURE",
  payload: error,
});

export const fetchStatus = (user_no) => async (dispatch) => {
  dispatch(fetchStatusStart());
  try {
    const res = await http.get(`api/status?user_no=${user_no}`);
    if (res.status !== 200) {
      throw new Error("Failed to fetch status data");
    }
    const statusData = await res.data;
    dispatch(fetchStatusSuccess(statusData));
  } catch (error) {
    dispatch(fetchStatusFailure(error.message));
  }
};

export const updateStatusStart = () => ({
  type: "UPDATE_STATUS_START",
});

export const updateStatusSuccess = (statusData) => ({
  type: "UPDATE_STATUS_SUCCESS",
  payload: statusData,
});

export const updateStatusFailure = (error) => ({
  type: "UPDATE_STATUS_FAILURE",
  payload: error,
});

export const updateStatus =
  ({ user_no, user_name, user_lang, bear_type, user_progress, bear_set }) =>
  async (dispatch) => {
    dispatch(updateStatusStart());
    try {
      const res = await http.post(`api/update`, {
        user_no,
        user_name,
        user_lang,
        bear_type,
        user_progress,
        bear_set,
      });
      if (res.status !== 200) {
        throw new Error("Failed to update status data");
      }
      const statusData = await res.data;
      dispatch(updateStatusSuccess(statusData));
      dispatch(updateUserName(statusData.user_name));
      return true;
    } catch (error) {
      dispatch(updateStatusFailure(error.message));
      return false;
    }
  };

export const updateUserName = (userName) => ({
  type: "UPDATE_NAME",
  payload: userName,
});
